export default "__VITE_ASSET__143a2749__$_?component__"